import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

interface UnsavedChangesPromptProps {
  when: boolean;
  message?: string;
}

export function UnsavedChangesPrompt({
  when,
  message = 'There are unsaved changes. Proceed anyway?',
}: UnsavedChangesPromptProps) {
  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const proceed = window.confirm(message);
      if (proceed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker, message]);

  return null;
}
